import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { StatusCardProps as Props } from './types';

export const StatusCard = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('StatusCard', className)}
      severity="success"
      icon={false}
      sx={SX.root}
    >
      New Credits are added to your Balance
    </Styled.Wrapper>
  );
});

StatusCard.displayName = 'StatusCard';
